import { useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import dayjs from 'dayjs';
import CreateTranscripts from 'components/Dashboard/Transcripts/CreateTranscripts';
import YourTranscripts from 'components/Dashboard/Transcripts/YourTranscripts';
import CreateTranscriptModal from 'components/Dashboard/Transcripts/CreateTranscriptModal';
import TranscriptsFilters from 'components/Dashboard/Transcripts/TranscriptsFilters';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';

const Transcripts = () => {
  const [activeDebate, setActiveDebate] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [transcripts, setTranscripts] = useState([]);
  const [activeSection, setActiveSection] = useState('All');
  const [date, setDateState] = useState(getUrlParam('date') ?? dayjs().format('YYYY-MM-DD'));

  const [heightContainer, containerRef] = useHeightContainer();

  const params = useParams();
  const navigate = useNavigate();
  const { section } = params ?? {};

  const createSection = section === 'create' || !section;
  const transcriptsSection = section === 'your-transcripts';

  // Keeps the create screen's date shareable/bookmarkable as a link.
  const setDate = (newDate) => {
    setDateState(newDate);
    navigate({ search: `date=${newDate}` });
  };

  return (
    <>
      <div className='specific-top-padding-8'>
        <div className='row mx-0'>
          <div className='px-0 flex-grow-1 mw-100' style={{ flex: 1 }}>
            <div className='box-rounded pb-lg-5 pb-3 reference-main-content'>
              {transcriptsSection && (
                <YourTranscripts
                  transcriptsState={{ transcripts, setTranscripts }}
                  openState={{ isOpen, setIsOpen }}
                  activeDebateState={{ activeDebate, setActiveDebate }}
                  activeSectionState={{ activeSection, setActiveSection }}
                />
              )}
              {createSection && (
                <CreateTranscripts
                  openState={{ isOpen, setIsOpen }}
                  activeDebateState={{ activeDebate, setActiveDebate }}
                  activeSectionState={{ activeSection, setActiveSection }}
                  dateState={{ date, setDate }}
                />
              )}
            </div>
          </div>
          <div className='ml-4 outside-filters-container' ref={containerRef}>
            <CustomScrollbar
              className={'main-content-scrollbar top-content-scrollbar'}
              style={{ height: `${heightContainer}px` }}
              maximalThumbYSize={100}
            >
              <TranscriptsFilters
                section={createSection ? 'create' : 'your-transcripts'}
                createFiltersState={{ activeSection, setActiveSection, date, setDate }}
              />
            </CustomScrollbar>
          </div>
        </div>
      </div>
      <CreateTranscriptModal
        openState={{ isOpen, setIsOpen }}
        activeDebateState={{ activeDebate, setActiveDebate }}
        setTranscripts={setTranscripts}
      />
    </>
  );
};

export default Transcripts;
